'use client';

import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { setUserPersistContext } from '@/lib/browser/userScopedStorage';
import { rehydrateSampleListFilterStores } from '@/lib/sampleList/rehydrateSampleListFilterStores';

/**
 * Keeps sample/substrate filter persistence scoped to the signed-in user.
 * Anonymous sessions use in-memory defaults only; impersonation reads but does not write.
 */
export function UserScopedFilterPersistInitializer() {
  const currentUser = useAuthStore((state) => state.currentUser);
  const lastScopeKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const userId = currentUser?.id ?? null;
    const isAnonymous = !currentUser || currentUser.isAnonymous;
    const usingSignInAs = currentUser?.usingSignInAs ?? false;

    setUserPersistContext({ userId, isAnonymous, usingSignInAs });

    const scopeKey = isAnonymous ? 'anonymous' : `${userId}:${usingSignInAs ? 'impersonate' : 'normal'}`;
    if (lastScopeKeyRef.current === scopeKey) return;
    lastScopeKeyRef.current = scopeKey;

    void rehydrateSampleListFilterStores();
  }, [currentUser]);

  return null;
}
